const stepsConfig = [
  {
    name: "name",
    label: "Name",
    type: "input",
    rules: [{ required: true, message: "Name is required!" }],
  },
  {
    name: "stepOwner",
    label: "Step Owner",
    type: "select",
    options: [],
    values: [],
    rules: [{ required: true, message: "Step Owner is required!" }],
  },
  {
    name: "stepDueDate",
    label: "Step Due Date",
    type: "datepicker",
    rules: [{ required: true, message: "Step Due Date is required!" }],
  },
];

export default stepsConfig;
